/**
 * BrandWordmark — peeka 워드마크 로고.
 *
 * 모바일 앱바와 데스크탑 상단바가 함께 쓴다. 예전에는 두 곳이 각자
 * 'PEEKA' 를 **글자로** 찍고 있었는데(에셋이 없어서), 서체·자간·크기가 서로 달라
 * 같은 브랜드가 화면마다 다르게 보였다.
 *
 * ⚠ 배경 밝기에 따라 **두 벌**이 있다. 워드마크가 흰 글자/짙은 글자로 갈리고,
 *   번개만 양쪽 다 브랜드 오렌지다. 어느 쪽을 쓸지는 CSS 가 `data-theme` 으로
 *   고른다 (BrandWordmark.module.css) — 이미지도 그때 쓰는 한 장만 내려받는다.
 *
 * ⚠ <img> 가 아니라 배경 이미지다. <img> 로 두면 테마에 따라 src 를 바꿔야 하는데,
 *   테마가 런타임에 바뀌므로 JS 가 개입해야 한다. 배경이면 CSS 만으로 끝난다.
 *   대신 스크린리더용 이름을 role/aria-label 로 직접 준다.
 */
import styles from "./BrandWordmark.module.css";

export interface BrandWordmarkProps {
  /**
   * 로고 높이(px). 폭은 원본 비율(1690:368)로 따라온다.
   * @default 15 — 앱바 기준. 20 에서 0.75 배로 줄였다 (2026-08-19). 앱바가 유리로
   *   바뀌면서 뒤 콘텐츠가 비치는데, 20px 워드마크는 그 위에서 혼자 무거웠다.
   *   높이를 명시해 부르는 곳(데스크탑 헤더 28 · 준비중 화면 24)은 그대로다.
   */
  height?: number;
}

export default function BrandWordmark({ height = 15 }: BrandWordmarkProps) {
  return (
    <span
      className={styles.wordmark}
      style={{ height }}
      role="img"
      aria-label="PEEKA"
    />
  );
}
